import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=eff3cd50&scoped=true&"
import script from "./SubmitBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=eff3cd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff3cd50",
  null
  
)

export default component.exports